import {GET_ADHAR_CARD_KYC_IMAGE, GET_ADHAR_CARD_KYC_REQ,GET_ADHAR_CARD_SUCCESS, ADHAR_CARD_ERROR,GET_ADHAR_CARD_IMAGE_RESET } from "../actionType";

export const getAdharcardImage = (image: any) => ({
    type: GET_ADHAR_CARD_KYC_IMAGE,
    payload: image
});

export const getAdharcardReq = (value: any) => ({
    type: GET_ADHAR_CARD_KYC_REQ,
    payload: value
});

export const getAdharcardReqSuccess = (data: any) => ({
    type: GET_ADHAR_CARD_SUCCESS,
    payload: data
});

export const getAdharcardReqError = (error: any) => ({
    type: ADHAR_CARD_ERROR,
    payload: error
});

export const getAdharcardImageReset = () => ({
    type: GET_ADHAR_CARD_IMAGE_RESET,
});